import { Typography, useTheme } from "@mui/material";
import {
    Blurb,
    ChatBlurb,
} from "../AcxTranscription/Components/BlurbBox/Blurb";
import React from "react";
import { sxClsx } from "utils/styleClsx";

export const P2BlurbText = ({
    blurb,
    dataRange,
}: {
    blurb: Blurb | ChatBlurb;
    dataRange: { startWordIndex: number; endWordIndex: number };
}) => {
    const theme = useTheme();

    if (
        blurb.firstWordIndex === undefined ||
        blurb.lastWordIndex === undefined
    ) {
        return <Typography>{blurb.text}</Typography>;
    }

    const blurbWords = blurb.text.split(" ");
    const modifiedBlurbWords: { word: string; inRange: boolean }[] =
        blurbWords.map((word, index) => {
            const wordIndex = index + blurb.firstWordIndex!;
            const inRange =
                wordIndex >= dataRange.startWordIndex &&
                wordIndex <= dataRange.endWordIndex - 1;
            return { word, inRange };
        });

    return (
        <Typography>
            {modifiedBlurbWords.map(({ word, inRange }, i) => (
                <Typography
                    component="span"
                    key={`${i}-${word}`}
                    sx={sxClsx(
                        inRange &&
                            blurb.foundEddy && {
                                color: theme.palette.highlight.eddy.main,
                                fontWeight: theme.typography.fontWeightSemibold,
                            },
                        inRange &&
                            blurb.foundAdverse && {
                                color: theme.palette.highlight.adverseEvent
                                    .main,
                                fontWeight: theme.typography.fontWeightSemibold,
                            },
                    )}
                >
                    {word + " "}
                </Typography>
            ))}
        </Typography>
    );
};
